type EmailInputOptions = {
  type?: string
  id?: string
  name?: string
  label?: string
}

export const isEmailInput = ({ type, id, name, label }: EmailInputOptions) =>
  type === 'email' ||
  id?.toLowerCase().includes('email') ||
  name?.toLowerCase().includes('email') ||
  label?.toLowerCase() === 'email'

export const normalizeEmailInputValue = (value: unknown, shouldNormalize: boolean) =>
  shouldNormalize && typeof value === 'string' ? value.toLowerCase() : value
